import { render, staticRenderFns } from "./Institutions.vue?vue&type=template&id=80a9a9ec&scoped=true&"
import script from "./Institutions.vue?vue&type=script&lang=js&"
export * from "./Institutions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80a9a9ec",
  null
  
)

export default component.exports